import {H5Text, H6Text} from '@buncha/components/core/text';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {HBox} from '@buncha/components/core/view';
import React from 'react';
import {StyleSheet} from 'react-native';

interface StepHeaderProps {
  textTitle: string;
  timeString: string;
}

const StepHeader: React.FC<StepHeaderProps> = props => {
  const {textTitle, timeString} = props;
  const theme = useColorThemeType();
  const muliFont = useFontTheme();
  return (
    <HBox style={styles.mainContainer}>
      <H5Text
        style={[
          styles.titleText,
          {
            color: theme?.text.blue[300],
            fontFamily: muliFont[600].normal,
          },
        ]}>
        {textTitle}
      </H5Text>
      <H6Text
        numberOfLines={1}
        style={[
          styles.subText,
          {
            color: theme?.text.gray[100],
            fontFamily: muliFont[400].normal,
          },
        ]}>
        {timeString}
      </H6Text>
    </HBox>
  );
};

export default React.memo(StepHeader);

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
  },
  titleText: {textAlign: 'left', flex: 1},
  subText: {
    textAlign: 'right',
    marginLeft: 5,
    alignSelf: 'flex-start',
    marginTop: 5,
  },
});
